var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 337.4 82.7",
    style: {
      enableBackground: "new 0 0 337.4 82.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-3850.2474,2468.1923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20018",
    transform: "translate(17.716516,17.702885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path19971",
    className: "st0",
    d: "M3872.3-2412c-18,0-32.7-14.7-32.7-33c0-18,14.7-32.7,32.7-32.7c18.2,0,33,14.7,33,32.7 C3905.2-2426.8,3890.5-2412,3872.3-2412z M3872.3-2425.8c10.7,0,19.2-8.5,19.2-19.2c0-10.5-8.5-19-19.2-19c-10.5,0-19,8.5-19,19 C3853.3-2434.3,3861.7-2425.8,3872.3-2425.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19973",
    className: "st0",
    d: "M4074.1-2412c-18,0-32.7-14.7-32.7-33c0-18,14.7-32.7,32.7-32.7c18.2,0,33,14.7,33,32.7 C4107.1-2426.8,4092.3-2412,4074.1-2412z M4074.1-2425.8c10.7,0,19.2-8.5,19.2-19.2c0-10.5-8.5-19-19.2-19c-10.5,0-19,8.5-19,19 C4055.1-2434.3,4063.6-2425.8,4074.1-2425.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19975",
    className: "st0",
    d: "M3909-2475.8v62.2h13.7v-50.7h15.3v50.7h13.7v-50.7h5.3c5.5,0,9.7,4.2,9.7,9.5v41.2h13.8 v-40.7c0-12.2-9.7-22-22-22H3923C3918.2-2476.3,3913.5-2476.3,3909-2475.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19977",
    className: "st0",
    d: "M4110.8-2475.8v62.2h13.7v-50.7h15.5c5.2,0,9.7,4.2,9.7,9.5v41.2h13.7v-40.7 c0-12.2-9.7-22-22-22h-17C4120.1-2476.3,4115.3-2476.3,4110.8-2475.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19979",
    className: "st0",
    d: "M3986.2-2475.8v62.2h13.7v-50.7h16.2c5.5,0,9.8,4.2,9.8,9.5c0,5.5-4.2,9.7-9.8,9.7h-11.7 l21.2,31.5h17l-15.5-22.7c7.5-2.7,12.5-10,12.5-18.5c0-11.7-9.5-21.5-21.5-21.5h-18.2C3995.2-2476.3,3990.7-2476.3,3986.2-2475.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmron);
export default __webpack_public_path__ + "static/media/omron.fc78289f6fd49d5c403c8ab1157cf4d3.svg";
export { ForwardRef as ReactComponent };